//
//
//
//
//
//

import i18n from "@/utils/i18n";
export default {
  name: "label-editor",
  mixins: [i18n],
  props: {
    designer: Object,
    selectedWidget: Object,
    optionModel: Object
  },
  computed: {
    noLabelSetting: function noLabelSetting() {
      return this.selectedWidget.type === 'static-text' || this.selectedWidget.type === 'html-text';
      //|| (this.selectedWidget.type === 'divider')
    }
  }
};